import { useState } from "react";
import Scrollable from "./shared/Scrollable";

function groupStoresByStoreNumber(stores = []) {
  const map = {};

  stores.forEach((item) => {
    if (!map[item.store]) {
      map[item.store] = {
        store: item.store,
        guid: item.guid,
        service: item.service,
        details: [],
      };
    }

    if (item.detail) {
      map[item.store].details.push(item.detail);
    }
  });

  return Object.values(map);
}

function AlertsAccordion({ alertsData, onStoreClick }) {
  const [openAlert, setOpenAlert] = useState(null);

  const toggleAlert = (alertName) => {
    setOpenAlert((prev) => (prev === alertName ? null : alertName));
  };

  const sortedAlerts = Object.values(alertsData || {}).sort(
    (a, b) => b.count - a.count
  );

  return (
    <div className="group-alert-wrapper">
      {sortedAlerts.map((grp) => {
        const isOpen = openAlert === grp.alert;
        const groupedStores = groupStoresByStoreNumber(grp.stores);

        return (
          <div key={grp.alert} className="group-alert-section">
            {/* Header */}
            <div
              className="group-alert-header"
              onClick={() => toggleAlert(grp.alert)}
            >
              <span>
                {grp.alert} ({grp.count})
              </span>
              <span
                className={`group-alert-arrow ${
                  isOpen ? "up" : "down"
                }`}
              />
            </div>

            {/* Body */}
            {isOpen && (
              <Scrollable className="group-alert-body">
                {groupedStores.map((item) => (
                  // <div
                  //   key={`${grp.alert}-${item.store}`}
                  //   className="group-alert-store issue-text"
                  //   onClick={() =>
                  //     onStoreClick?.(
                  //       item.guid ?? "NOGUID",
                  //       item.store,
                  //       (item.service || "").toUpperCase()
                  //     )
                  //   }
                  // >
                  //   {item.store} - {item.details.join(", ")}
                  // </div>
                  <div
  key={`${grp.alert}-${item.store}`}
  className="group-alert-store issue-text"
  onClick={() =>
    onStoreClick?.(
      item.guid ?? "NOGUID",
      item.store,
      (item.service || "").toUpperCase(),
      grp.alert
    )
  }
>
  <strong className="group-alert-store-id">
    {item.store}
  </strong>
  <span className="group-alert-separator"> - </span>
  <span className="group-alert-details">
    {item.details.join(", ")}
  </span>
</div>
                ))}
              </Scrollable>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default AlertsAccordion;

// import { useState } from "react";

// function AlertsAccordion({ alertsData = {}, onStoreClick }) {
//   const [openAlert, setOpenAlert] = useState(null);

//   const toggleAlert = (alertName) => {
//     setOpenAlert((prev) => (prev === alertName ? null : alertName));
//   };

//   const sortedAlerts = Object.values(alertsData).sort(
//     (a, b) => b.count - a.count,
//   );

//   // const cleanDetail = (detail = "", alertName = "") => {
//   //   if (!detail) return "";
//   //   return detail.replace(alertName, "").trim();
//   // };
// // const cleanDetail = (detail = "", alertName = "", maxLength = 20, tooltip="") => {
// //   if (!detail) return "";

// //   const cleaned = detail.replace(alertName, "").trim();
// //   if(tooltip === "cleaned") return cleaned;  // for tooltip, return full cleaned text
// //   return cleaned.length > maxLength
// //     ? `${cleaned.slice(0, maxLength)}…`
// //     : cleaned;
// // };
// const cleanDetail = (
//   detail = "",
//   alertName = "",
//   maxLength = 20,
//   fullText = false
// ) => {
//   if (!detail) return "";

//   const cleaned = detail.replace(alertName, "").trim();



//   return fullText
//     ? cleaned
//     : cleaned.length > maxLength
//       ? `${cleaned.slice(0, maxLength)}…`
//       : cleaned;
// };
// ``
//   return (
//     <div className="rt-alt-wrapper">
//       {sortedAlerts.map((grp) => {
//         const isOpen = openAlert === grp.alert;

//         return (
//           <div key={grp.alert} className="rt-alt-section">
//             <div
//               className="rt-alt-header"
//               onClick={() => toggleAlert(grp.alert)}
//             >
//               <div className="rt-alt-left">{grp.alert}</div>

//               <div className="rt-alt-right">
//                 <span className="rt-alt-count">({grp.count})</span>
//                 <span className={`rt-alt-arrow ${isOpen ? "up" : "down"}`} />
//               </div>
//             </div>

//             {/* {isOpen && (
//               <div className="rt-alt-body">
//                 {(grp.stores || []).map((item) => (
//                   <div
//                     key={item.guid || `${grp.alert}-${item.store}`}
//                     className="rt-alt-item issue-text"
//                     onClick={() =>
//                       onStoreClick?.(
//                         item.guid,
//                         item.store,
//                         (item.service || "").toUpperCase(),
//                       )
//                     }
//                   >
//                     <div className="rt-alt-item-content">

                  
//                       <span className="rt-alt-store">{item.store}</span>
//                       {/* <span className="rt-alt-detail">
//                         {cleanDetail(item.detail, grp.alert)}
//                         {console.log(
//                           "Detail:",
//                           item.detail,
//                           "Cleaned:",
//                           cleanDetail(item.detail, grp.alert),
//                         )}
//                       </span> 
                      
// <span
//   className="rt-alt-detail"
//    title={cleanDetail(item.detail, grp.alert, 20, true)}
// >
//   {cleanDetail(item.detail, grp.alert)}
// </span>

//                     </div>

//                     {/* <div className="rt-alt-item-content">
                      
//                       <div className="rt-alt-line">
//                         <span className="rt-alt-store">{item.store}</span>
//                         <span className="rt-alt-detail">
//                           {cleanDetail(item.detail, grp.alert)}
//                           {console.log("Detail:", item.detail, "Cleaned:", cleanDetail(item.detail, grp.alert))}
//                         </span>
//                       </div>
//                     </div> *
//                   </div>
//                 ))}
//               </div>
//             )} */}

//             {isOpen && (
//   <div className="rt-alt-body">
//     {(grp.stores || []).map((item) => {
//       const fullDetail = cleanDetail(item.detail, grp.alert, 20, true);
//       const parts = fullDetail ? fullDetail.split(" - ") : [];
//       const mainPart = parts[0] || "";
//       const subPart = parts.slice(1).join(" - ");

//       return (
//         <div
//           key={item.guid || `${grp.alert}-${item.store}`}
//           className="rt-alt-item issue-text"
//           onClick={() =>
//             onStoreClick?.(
//               item.guid,
//               item.store,
//               (item.service || "").toUpperCase()
//             )
//           }
//         >
//           <div className="rt-alt-item-content">
//             <span className="rt-alt-store">{item.store} - {mainPart}</span>

//             <span
//               className="rt-alt-detail"
//               title={fullDetail}   //  full text on hover
//             >
//                {subPart}
//             </span>

//             {/* {subPart && (
//               <span className="rt-alt-sub-detail">
              
//               </span>
//             )} */}
//           </div>
//         </div>
//       );
//     })}
//   </div>
// )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// export default AlertsAccordion;




// import { useState } from "react";

// function AlertsAccordion({ alertsData, onStoreClick }) {
//   const [openAlert, setOpenAlert] = useState(null);

//   const toggleAlert = (alertName) => {
//     setOpenAlert((prev) => (prev === alertName ? null : alertName));
//   };

//   const sortedAlerts = Object.values(alertsData || {}).sort(
//     (a, b) => b.count - a.count
//   );

//   return (
//   <div className="group-alert-wrapper">
//   {sortedAlerts.map((grp) => {
//     const isOpen = openAlert === grp.alert;

//     return (
//       <div key={grp.alert} className="group-alert-section">
//         {/* Header */}
//         <div
//           className="group-alert-header"
//           onClick={() => toggleAlert(grp.alert)}
//         >
//           <span>
//             {grp.alert} ({grp.count})
//           </span>
//           <span
//             className={`group-alert-arrow ${
//               isOpen ? "up" : "down"
//             }`}
//           />
//         </div>

//         {/* Body */}
//         {isOpen && (
//           <div className="group-alert-body">
//             {(grp.stores || []).map((item) => (
//               <div
//                 key={item.guid || `${grp.alert}-${item.store}`}
//                 className="group-alert-store issue-text"
//                 onClick={() =>
//                   onStoreClick?.(
//                     item.guid,
//                     item.store,
//                     (item.service || '').toUpperCase()
//                   )
//                 }
//               >
//                 {item.store} - {item.detail}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   })}
// </div>

//   );
// }

// export default AlertsAccordion;
